import './mainPage.css'

import ParallaxEffect from './components/parallaxEffect/parallaxEffect.js';
import Studies from './components/studies/studies.js';
import TransitionEffect from './components/transitionEffect/transitionEffect.js';
import Professional from './components/professional/professional.js';
import Personnal from './components/personnal/personnal.js';
import Contact from './components/contact/contact.js';
import Presentation from './components/presentation/presentation.js';

export default function MainPage({toastRef}) {

    return (

        <>
           <ParallaxEffect />
           <Presentation/>
           <TransitionEffect topOriented={true}/>
           <Studies/>
           <TransitionEffect topOriented={false}/>
           <Professional/>
           <TransitionEffect topOriented={true}/>
           <Personnal/>
           <TransitionEffect topOriented={false}/>
           <Contact/>
        </>
    )

}